<template>
  <div class="productPage tinyScreenProduct" id="tinyScreenProduct">
    <Header></Header>
    <!-- banner -->
    <div class="bannerHeaderBox">
      <div class="container">
        <div class="storyTxt">
          <div v-if="lang == 'en'">
            <h5>{{bannerBox.enSubContent}}</h5>
            <span>{{bannerBox.enContent}}</span>
          </div>
          <div v-else>
            <h5>{{bannerBox.cnSubContent}}</h5>
            <span>{{bannerBox.cnContent}}</span>
          </div>
        </div>
        <img class="fr mt30 phonePic" width="300px" :src="bannerBox.pcAdvertUrl">
      </div>
    </div>

    <!-- <div class="bannerBox">
      <div class="container">
        <div class="storyTxt">
          <span>佳期旗下产品</span>
          <img height="48px" src="../../assets/picture/product/list1.png">
        </div>
        <img class="fr mt30" width="300px" src="../../assets/picture/product/t12.png">
      </div>
    </div> -->
    <!-- section1 -->
    <div class="section1">
      <div class="container">
        <p class="title">旗下产品</p>
        <el-table class="tableBox" :header-cell-style="{background:'#900211',color:'#fff','text-align':'center'}"
        :data="tableData"
    :cell-style="{'text-align':'center'}"
        style="width: 100%">
          <el-table-column
            prop="productFullName"
            label="产品名称">
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="基金类别">
          </el-table-column>
          <el-table-column v-if="isPC"
            prop="address"
            label="证券经纪人">
          </el-table-column>
          <el-table-column v-if="isPC"
            prop="createTime"
            label="开放日">
            <template slot-scope="scope">
              <span>{{scope.row.createTime | formatDate}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="address" v-if="isPC"
            label="单位净值">
          </el-table-column>
          <el-table-column
            prop="address" v-if="isPC"
            label="认购起点">
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button class="detialBtn" @click="goDetail(scope.row.id)" type="text" size="small">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
         <el-pagination class="pagination" @current-change="handleChangePage" :total="dataTotal"
          @size-change="handleSizeChange" :current-page.sync="fromData.pageNum"
            layout="prev, pager, next" :page-size="fromData.pageSize">
          </el-pagination>
      </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
import {formatDate} from '../../plugins/formatDate.js'
export default {
  data() {
    return {
      liIndex:-1,
      isShowSearch:false,
      fromData:{
          pageNum:1,
          pageSize:10,
          typeId:''
      },
      dataTotal:0,
      lang:'',
      bannerBox:{
        pcAdvertUrl:'',
        mobileAdvertUrl:'',
        cnContent:'',
        cnSubContent:'',
        enContent: '',
        enSubContent: '',
      },
      tableData: [
        {
          productFullName:'星际一期',
          typeName:'资产配置',
        },
         {
          productFullName:'星际一期',
          typeName:'资产配置',
        }
      ],
      isPC:true,
    };
  },
  components: { Header,Footer },
  filters: {
      formatDate(time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      }
  },
  created(){
    this.lang = window.sessionStorage.getItem("language")?window.sessionStorage.getItem("language"):'cn';
  },
  mounted(){
    this.getAdvert();
    this.loadData();
    this.width =  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if(this.width<1023){
      this.isPC=false;
    }
  },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    goDetail(id){
       this.$router.push({  
            path: 'productDetail',     
            query: {   
                id: id,   
            }   
        })  
    },
     //分页获取产品信息
     async loadData() {
         const { data: res } = await this.$http.get("/product/getProductByPage.do?pageNum="+this.fromData.pageNum+"&pageSize="+this.fromData.pageSize+"&typeId="+this.fromData.typeId);
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
       this.tableData = res.data.list;
       this.total = res.data.total;
    },
    handleChangePage(pageNum) {
      this.fromData.pageNum = pageNum;
      this.loadData();
    },
    // 切换单页数量事件
    handleSizeChange(pageSize) {
      this.fromData.pageSize = pageSize;
      this.loadData();
    },
     // 根据埋点ID及非必填项获取广告位
    async getAdvert() {
        const { data: res } = await this.$http.get("/advert/getAdvert.do?pointId=17");
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.bannerBox = {
          ...res.data[0]
        };
    },
  }
};
</script>

<style lang="less" scoped>
.productPage{
  .bannerHeaderBox{    
    width: 100%;
    height: 360px;
    background: #333333;
    display: flex;
    .storyTxt{
        display: inline-block;
        padding-top: 112px;
       h5{      
        font-size: 14px;
        /*font-family: PingFangSC-Medium, PingFang SC;*/
        font-weight: 100;
        color: #fff;
        line-height: 22px;
        margin-bottom: 36px;
      }
      span{
        font-size: 40px;
         font-weight: 100;
         color: #fff;
      }
       img{      
        margin-top: 50px;
      }
    }
  }
  /*********************************************/
  .section1{
    padding-bottom: 193px;
    .title{
      padding:120px 0 52px 0;
      text-align: center;
      font-size: 35px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #900211;
      line-height: 49px;
      letter-spacing: 2px;
    }
    /deep/ .el-table td, .el-table th{
      padding:30px 0;
    }
    .detialBtn{
      width: 130px;
      height: 44px;
      border: 1px solid #900211;
      text-align: center;
      line-height: 44px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #900211;
      line-height: 20px;
    }
    .pagination{
      text-align: center;
      margin-top: 55px;
      /deep/ .el-pager li.active{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #900211;
      }
      /deep/ .el-pager li{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #9A9A9A;
      }
      /deep/ .btn-next{
        color:#900211 !important;
      }
      /deep/ .btn-next:hover{
        color:#900211;
      }
    }
  }
}
</style>
